module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#album",
      toString: function () {
        return this.url;
      }
    }